import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { BillingRun } from 'src/features/billingRuns/utils/types';
import { TriggerBillingRunFormSchemaValues } from 'src/features/billingRuns/utils/formSchema';

const RESOURCE = '/charges/billing-run/trigger/';

type MutationFnType = typeof mutationFn;

/**
 * Starts a manual fan-out. Verified against the live API: returns 201 with the run (the OpenAPI
 * schema declares 200, which is wrong). Manual runs are not limited to once a day.
 */
const mutationFn = (data: TriggerBillingRunFormSchemaValues): Promise<BillingRun> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useTriggerBillingRun };
